import React from "react";
import "./Banner.css";
import BannerImg from "../../assets/img/banner.png";
const Banner = ({ buyTokenRef }) => {

  const scrollToSection = () => {
    const section = document.getElementById('buy-tokens');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className="main-banner container-width"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      <div className="banner-text">
        <h1>
          GET IN ON THE GROUND FLOOR! THE BLUE SOCIAL TOKEN IS GOING LIVE ON UNISWAP JULY 1, 2024.
        </h1>
        <p>
          Blue Social is the world's first Socialize-to-Earn platform that uses
          Self-Sovereign Digital Identities and lets you earn rewards and make
          money through meeting others [and other simple social actions].
        </p>
        <div className="btn-container">
          <a onClick={scrollToSection} className="blue-btn">
            Buy Now
          </a>
          <a href="https://blue-social.gitbook.io/blue-social-white-paper/" target="_blank" className="simple-btn">
            Whitepaper
          </a>
        </div>
      </div>
      <div className="banner-img">
        <img src={BannerImg} alt="" />
      </div>
    </div>
  );
};

export default Banner;
